import React from 'react';
import { HexagonDice } from 'iconoir-react';
import { useSentenceRotator } from '../../hooks/useSentenceRotator';
import { aiLoaderMainSentence, aiLoaderSentences } from '../../lib/constants';

const AISummaryLoader = () => {
  const { mainSentence, secondSentence } = useSentenceRotator({
    mainSentence: aiLoaderMainSentence,
    sentences: aiLoaderSentences,
  });

  return (
    <div className='h-[calc(100vh-6rem)] overflow-y-auto mt-2'>
      <div className='container px-4 py-6 md:px-8 md:pt-[3.5625rem] md:pb-[6.5rem]'>
        <h2 className='mb-1 font-heading !font-medium text-heading-500 flex items-center gap-2'>
          <HexagonDice className='w-12 h-12 object-contain' />
          AI Summary
        </h2>
        <p className='mb-10 text-body-400'></p>
        <div className='mb-6 animate-pulse'>
          <div className='shimmer heading w-full max-w-[18rem]'></div>
          <div className='shimmer w-full max-w-[60%]'></div>
          <div className='shimmer w-full max-w-[60%]'></div>
          <div className='shimmer w-full max-w-[60%]'></div>
          <div className='shimmer w-full max-w-[25%]'></div>
        </div>
        <div className='mb-6 animate-pulse'>
          <div className='shimmer heading w-full max-w-[15rem]'></div>
          <div className='shimmer w-full'></div>
          <div className='shimmer w-full'></div>
          <div className='shimmer w-full'></div>
          <div className='shimmer w-full'></div>
        </div>
        <div className='mb-6 animate-pulse relative'>
          <div className='shimmer heading w-full max-w-[18rem]'></div>
          <div className='shimmer w-full'></div>
          <div className='shimmer w-full'></div>
          <div className='shimmer w-full'></div>
          <div className='shimmer w-full'></div>
          <div className='absolute left-[50%] right-[50%] translate-x-[-50%] bottom-0 top-0 text-center w-full h-full flex items-center justify-center'>
            <h5 className='text-body-100 !font-medium mb-0 bg-white p-1 rounded-xl mt-3 w-full'>
              {mainSentence}
              <br />
              <span className='text-body-100 !font-medium font-heading'>
                {secondSentence}
              </span>
            </h5>
          </div>
        </div>
        <div className='mb-6 animate-pulse'>
          <div className='shimmer heading w-full max-w-[15rem]'></div>
          <div className='shimmer w-full'></div>
          <div className='shimmer w-full'></div>
          <div className='shimmer w-full'></div>
          <div className='shimmer w-full'></div>
        </div>
        <div className='mb-6 animate-pulse'>
          <div className='shimmer heading w-full max-w-[18rem]'></div>
          <div className='shimmer w-full max-w-[60%]'></div>
          <div className='shimmer w-full max-w-[60%]'></div>
          <div className='shimmer w-full max-w-[60%]'></div>
          <div className='shimmer w-full max-w-[25%]'></div>
        </div>
      </div>
      <div className='container px-4 md:px-8 pb-[6.5rem]'>
        <div className='animate-pulse sm:flex justify-end gap-2'>
          <div className='shimmer flex items-center gap-2 sm:mb-0 mb-2 !h-12 sm:w-[12.5rem] w-full !rounded-lg'></div>
          <div className='shimmer flex items-center gap-2 !h-12 sm:w-[10.875rem] w-full !rounded-lg'></div>
        </div>
      </div>
    </div>
  );
};

export default AISummaryLoader;
